/**
 * @generated SignedSource<<3149e14b40e79b4641e8713081b8bcd4>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 * Schema: cc
 *
 * @see https://go/typsy
 **/

export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export enum AccessType {
  EDIT = "EDIT",
  VIEW = "VIEW",
}
export interface RequestPageAccessInput {
  accessType: AccessType;
  pageId: Scalars["String"]["input"];
}
export type restrictedPageRequestPageAccessMutation_requestPageAccess_RequestPageAccessPayload =
  {
    __typename?: "RequestPageAccessPayload";
    displayName: string;
  };
export type restrictedPageRequestPageAccessMutation_Mutation = {
  __typename?: "Mutation";
  requestPageAccess: restrictedPageRequestPageAccessMutation_requestPageAccess_RequestPageAccessPayload;
};
export type restrictedPageRequestPageAccessMutationVariables = Exact<{
  requestPageAccessInput: RequestPageAccessInput;
}>;
export type restrictedPageRequestPageAccessMutation =
  restrictedPageRequestPageAccessMutation_Mutation;
